import Vue from 'vue';

export default {
    getSavedJobs() {
        const url = 'v1/me/list-job?url=saved-jobs&sort_by=relevance';
        return Vue.$axios.$get(url);
    },

    getAppliedJobs() {
        const url = 'v1/me/job-applications?sort_by=relevance';
        return Vue.$axios.$get(url);
    },
};
